<template>
	<div class="">
		<vxe-table :ref="ref" size="mini" border height="300" :row-config="{isCurrent: true, isHover: true}"
			:radio-config="{labelField: 'name', trigger: 'row'}" :data="tableData">
			<vxe-column type="radio" field="name" title="名称" width="120"></vxe-column>
			<vxe-column field="target" title="目的地">
				<template #default="{ row }">
					{{getCity(row.target)}}
				</template>
			</vxe-column>
			<vxe-column field="minweight" title="最小重量"></vxe-column>
			<vxe-column field="maxweight" title="最大重量"></vxe-column>
			<vxe-column field="price" title="价格"></vxe-column>
			<vxe-column field="firstweight" title="首重"></vxe-column>
			<vxe-column field="afterweight" title="续重"></vxe-column>
			<vxe-column field="amount" title="总价"></vxe-column>
		</vxe-table>
	</div>
</template>
<style scoped>

</style>
<script>
	export default {
		props: {
			weight: {
				default: () => {
					return 0
				}
			},
			province: {
				default: () => {
					return 0
				}
			}
		},
		data() {
			return {
				tableData: [],
				ref:Math.random()
			}
		},
		created() {
			this.$api.offer.getDelivery({
				weight: this.weight,
				target: this.province[0]
			}).then((res) => {
				this.tableData = res
			})
		},
		mounted() {

		},
		watch: {

		},
		computed: {

		},

		methods: {
			submit() {
				return this.$refs[this.ref].getRadioRecord()
			},
			getCity(value){
				return window.systemMethods.getEmunValue('city',value)
			}
		},
		components: {

		}
	}
</script>
